// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"ecb02dfc","662":"9a5bf37b"}[chunkId] + ".chunk.js";
};